import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom";
import './assets/css/globals.css'
import {GoogleReCaptchaProvider} from "react-google-recaptcha-v3";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <GoogleReCaptchaProvider
            reCaptchaKey="6LfzUcEqAAAAAERp8ZAha3haRDQzMhSL-IZ85iaL"
            scriptProps={{
                async: true,
                defer: true,
                appendTo: 'body',
            }}
        >
            <BrowserRouter>
                <App/>
            </BrowserRouter>
        </GoogleReCaptchaProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
